/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Visit } from '../../models/visit';

export interface GetVisitForAnimal$Params {
  animalId: string;

/**
 * Max. number of returned visits. Allowed values 0 < count <= 200
 */
  count?: number;
}

export function getVisitForAnimal(http: HttpClient, rootUrl: string, params: GetVisitForAnimal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Visit>>> {
  const rb = new RequestBuilder(rootUrl, getVisitForAnimal.PATH, 'get');
  if (params) {
    rb.query('animalId', params.animalId, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Visit>>;
    })
  );
}

getVisitForAnimal.PATH = '/api/visits';
